<template>
  <div class="logo-maker-container">
    <div class="logo-maker-loader" v-show="!isReady"><div class="loader"></div></div>
    <div class="logo-maker" :style="{ visibility: isReady ? 'visible': 'hidden' } ">
      <div class="logo-maker-menu">
        <div class="logo-maker-menu__item">
          <label for="logoMakerText" class="logo-maker-menu__label">Название вашей фирмы</label>
          <input id="logoMakerText" @focus="openToolbox('text')" class="logo-maker-menu__form-control" type="text" placeholder="Название вашей фирмы" v-model="text">
          <div class="logo-maker-toolbox" id="textToolbox" v-show="toolbox === 'text'">
            <sketch-picker v-model="textColors" @change-color="changeColorText"></sketch-picker>
            <div class="logo-maker-toolbox__close" @click="toolbox = ''"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 64 64"><g><path d="M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"></path></g></svg></div></div>
        </div>
        <div class="logo-maker-menu__item">
          <label for="logoMakerFont" class="logo-maker-menu__label">
            Шрифт названия
          </label>
          <div class="logo-maker-menu__fontstyle">
            <label class="logo-maker-menu__fontstyle-label">
              <input type="checkbox"  class="logo-maker-menu__fontstyle-checkbox" v-model="textBold" :disabled="!(font.Bold && (textItalic ? font.BoldItalic : true))">
              <span class="logo-maker-menu__fontstyle-icon"><svg version="1.1" width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve"><g><path d="M10.3,7.8c0.8,0.2,2.2,0.5,2.2,2c0,0.6-0.2,1.1-0.7,1.5c-0.6,0.5-1.4,0.7-2.6,0.7h-4v-0.2c0.4,0,0.6,0,0.7-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.4,0.1-0.8V5.4c0-0.4,0-0.7-0.1-0.8C6.2,4.5,6.1,4.4,6,4.4C5.8,4.3,5.6,4.3,5.2,4.3V4H9C10,4,10.6,4.1,11,4.3c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.7,0.3,1c0,0.4-0.1,0.7-0.4,1C11.5,7.4,11,7.6,10.3,7.8z M8.2,8.1l0,2.8c0,0.2,0.1,0.4,0.2,0.5s1.1,0,1.3,0c1-0.2,1.5-2.2,0.2-2.9C9.6,8.3,8.8,8.1,8.2,8.1z M8.2,7.6c0.6,0,1.9-0.2,1.9-1.2c0-2-1-1.9-1.9-1.9V7.6z"/></g></svg></span>
            </label>
            <label class="logo-maker-menu__fontstyle-label">
              <input type="checkbox" class="logo-maker-menu__fontstyle-checkbox" v-model="textItalic" :disabled="!(font.Italic && (textBold ? font.BoldItalic : true))">
              <span class="logo-maker-menu__fontstyle-icon"><svg version="1.1" width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve"><g><path d="M8.3,11.8L8.3,12H5l0.1-0.2c0.3,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.2,0.3-0.5,0.4-1l1.4-4.8C8,5.3,8.1,5,8.1,4.8c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.3-0.1-0.6-0.1l0.1-0.2h3.1l-0.1,0.2c-0.2,0-0.4,0-0.6,0.1C9.5,4.4,9.3,4.6,9.3,4.7C9.2,4.8,9,5.2,8.9,5.7l-1.4,4.8c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2C7.8,11.7,8,11.8,8.3,11.8z"/></g></svg></span>
            </label>
          </div>
          <select id="logoMakerFont" class="logo-maker-menu__form-control" type="text" placeholder="Шрифт названия" v-model="textStyle.fontFamily" @change.stop="changeFont(this)">
            <option v-for="font in fonts">{{ font.name }}</option>
          </select>
        </div>

        <div class="logo-maker-menu__item">
          <label for="logoMakerTheme" class="logo-maker-menu__label">Тематика</label>
          <select id="logoMakerTheme" class="logo-maker-menu__form-control" type="text" v-model="theme">
            <option v-for="(name, key) in themes" :value="key"> {{ name }} </option>
          </select>
        </div>

        <div class="logo-maker-menu__item">
          <label for="logoMakerIcon" class="logo-maker-menu__label">Иконка</label>
          <div class="logo-maker-icons">
            <div class="logo-maker-icons__item" v-for="(url, i) in icons">
              <input class="logo-maker-icons__radio" type="radio" :id="'logoMakerIcon_' + i" :value="i" v-model="icon">
              <label :for="'logoMakerIcon_' + i" class="logo-maker-icons__icon" @click="openToolbox('icon')"><img alt="" :src="getIconUrl(i)" width="32" height="32"></label>
            </div>
          </div>
          <div class="logo-maker-toolbox" id="icnToolbox" v-show="toolbox === 'icon'">
            <sketch-picker v-model="iconColors" @change-color="changeColorIcon"></sketch-picker>
            <div class="logo-maker-toolbox__close" @click="toolbox = ''"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 64 64"><g><path d="M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"></path></g></svg></div>
          </div>
        </div>

        <div class="logo-maker-menu__item">
          <div class="logo-maker-menu__half" style="width: 65%">
            <label for="logoMakerIcon" class="logo-maker-menu__label">Положение</label>
            <div class="logo-maker-uicons">
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconPosition" value="left" id="logoMakerIconPosition_left">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_left">
                  <img src="static/ui-icons/ui_left.svg" alt="left" title="left" class="logo-maker-uicons__icon">
                </label>
              </div>
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconPosition" value="top" id="logoMakerIconPosition_top">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_top">
                  <img src="static/ui-icons/ui_top.svg" alt="top" title="top" class="logo-maker-uicons__icon">
                </label>
              </div>
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconPosition" value="right" id="logoMakerIconPosition_right">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_right">
                  <img src="static/ui-icons/ui_right.svg" alt="left" title="left" class="logo-maker-uicons__icon">
                </label>
              </div>
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconPosition" value="bottom" id="logoMakerIconPosition_bottom">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_bottom">
                  <img src="static/ui-icons/ui_bottom.svg" alt="bottom" title="bottom" class="logo-maker-uicons__icon">
                </label>
              </div>
            </div>
          </div>
          <div class="logo-maker-menu__half" style="width: 35%">
            <label for="logoMakerIcon" class="logo-maker-menu__label">Размер</label>
            <div class="logo-maker-uicons">
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconScale" value="0.75" id="logoMakerIconPosition_075">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_075">
                  <img src="static/ui-icons/ui_size1.svg" alt="0.75" title="0.75" class="logo-maker-uicons__icon">
                </label>
              </div>
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconScale" value="1" id="logoMakerIconPosition_1">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_1">
                  <img src="static/ui-icons/ui_size2.svg" alt="1" title="1" class="logo-maker-uicons__icon">
                </label>
              </div>
              <div class="logo-maker-uicons__item">
                <input class="logo-maker-uicons__radio" type="radio" v-model="iconScale" value="1.5" id="logoMakerIconPosition_15">
                <label class="logo-maker-uicons__label" for="logoMakerIconPosition_15">
                  <img src="static/ui-icons/ui_size3.svg" alt="1.5" title="1.5" class="logo-maker-uicons__icon">
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="logo-maker-menu__item">
          <label for="logoMakerIcon" class="logo-maker-menu__label">Рамка</label>
          <div class="logo-maker-icons logo-maker-icons--shape" style="max-height: 197px;">
            <div class="logo-maker-icons__item" v-for="i in shapes">
              <input class="logo-maker-icons__radio" type="radio" :id="'logoMakerShape_' + i" :value="i" v-model="shape">
              <label v-if="i=='none'" :for="'logoMakerShape_' + i" class="logo-maker-icons__icon">
                <div style="width: 45px;height: 45px;color: #000;font-weight: bold;  line-height: 45px;text-align: center;">Нет</div>
              </label>
              <label v-else :for="'logoMakerShape_' + i" class="logo-maker-icons__icon"><img alt="" :src="'static/shapes/' + i + '.svg'" width="42" height="42"></label>
            </div>
          </div>
        </div>
      </div>

      <div class="logo-maker-workarea-wrap">
        <div id="logoMakerWorkarea" class="logo-maker-workarea">
          <svg class="logo-maker-svg">
            <g class="logo-maker-svg__inner">
              <text text-anchor="middle" :fill="textColor" :style="{ fontWeight: textBold ? 'bold' : 'normal', fontStyle: textItalic ? 'italic' : 'normal', fontSize: textStyle.fontSize, fontFamily: '\'' + textStyle.fontFamily + '\'' }" :transform="textTransform">{{ text }}</text>
              <g v-if="!hasShape()" :transform="iconTransform" v-html="iconHTML" :fill="iconColor" class="icon-wrap"></g>
              <g v-else :transform="iconTransform"  :fill="iconColor" class="icon-wrap">
                <g transform="matrix(0.8, 0, 0, 0.8, 22, 22)" v-html="iconHTML"></g>
                <g x="0" y="0" transform="matrix(1, 0, 0, 1, 0, 0)" v-html="shapePath"></g>
              </g>
            </g>
          </svg>
        </div>
        <div class="logo-maker-info">
          <div class="logo-maker-get-logo">
            <button class="logo-maker-get-logo__btn" @click="getLogo">Забрать свой логотип</button>
          </div>
          <div style="max-width: 520px;">
            Конструктор логотипов - инструмент, который позволит вам создать профессиональный логотип вашей компании в считанные минуты - даже если у вас нет навыков работы в графических редакторах.
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import Promise from 'bluebird'
import debounce from 'debounce'
import { Sketch } from 'vue-color'
import WebFont from 'webfontloader'
import LogoMaker from './logomaker'

var iconsCache = {}

const shapes = [
  'none',
  'Shape_-01',
  'Shape_-02',
  'Shape_-03',
  'Shape_-04',
  'Shape_-05',
  'Shape_-06',
  'Shape_-07',
  'Shape_-08',
  'Shape_-09',
  'Shape_-10',
  'Shape_-11',
  'Shape_-12',
  'Shape_-13',
  'Shape_-14',
  'Shape_-15',
  'Shape_-17',
  'Shape_-18',
  'Shape_-19',
  'Shape_-20',
  'Shape_-21',
  'Shape_-22',
  'Shape_-23',
  'Shape_-24',
  'Shape_-25'
  // 'Shape_-26'
]

export default {
  name: 'app',

  mounted () {
    this.ready()

    if (window.addEventListener) {
      window.addEventListener('resize', () => {
        this.computeWorkareaSize()
        this.textAlign()
        this.iconAlign()
      })
    } else if (window.attachEvent) {
      window.attachEvent('onresize', () => {
        this.computeWorkareaSize()
        this.textAlign()
        this.iconAlign()
      })
    }
  },

  data () {
    return {
      // common
      isReady: false,
      // Workarea
      workareaSize: undefined,
      // Text
      fonts: [],
      text: 'Logo•Laba',
      textTransform: '',
      textColors: {},
      textColor: '',
      textStyle: {
        fontSize: '32px',
        fontFamily: 'Lobster'
      },
      textBold: false,
      textItalic: false,
      // icon
      themes: {},
      theme: 'education',
      icons: [],
      icon: '',
      iconHTML: '',
      iconSize: {width: 0, height: 0},
      iconScale: 1,
      iconPosition: 'top',
      iconTransform: '',
      iconColors: {},
      iconColor: '#D0021B',
      // toolbox
      toolbox: '',
      // shape
      shapes: shapes,
      shape: 'none',
      shapePath: ''
    }
  },

  methods: {

    ready () {
      return this.$http.get('static/themes.json')
        .then((response) => {
          this.themes = response.data
          return this.themes
        })
        .then(() => {
          return Promise.all([this.loadIcons(), this.loadFonts()])
        })
      // return Promise.all([this.loadIcons(), this.loadFonts()])
        .then(() => {
          this.textStyle.fontFamily = this.fonts[0].name
          return this.waitFont(this.textStyle.fontFamily)
        })
        .then(this.computeWorkareaSize)
        .then(this.textAlign)
        .then(() => {
          this.icon = Object.keys(this.icons)[0]
          return this.waitIcon(this.icon)
        })
        .then(() => new Promise((resolve) => {
          setTimeout(() => {
            this.isReady = true
            this.listenToolboxClose()
            resolve(this.isReady)
          }, 300)
        }))
    },

    computeWorkareaSize () {
      const workarea = this.$el.querySelector('.logo-maker-workarea')
      this.workareaSize = {
        width: workarea.clientWidth,
        height: workarea.clientHeight
      }

      return workarea
    },

    textAlign () {
      let x = this.workareaSize.width / 2
      let y = this.workareaSize.height / 2
      let scale = this.getResize()
      this.textTransform = 'matrix(' + scale + ', 0, 0, ' + scale + ', ' + x + ', ' + y + ')'

      return this.textTransform
    },

    getTextSize () {
      const text = this.$el.querySelector('.logo-maker-workarea text')
      var width = 0
      var height = 0

      if (text) {
        width = text.getBoundingClientRect().width
        height = text.getBoundingClientRect().height
      }

      return {
        width: width,
        height: height
      }
    },

    getTextPosition () {
      const workarea = this.$el.querySelector('.logo-maker-workarea')
      const text = workarea.querySelector('.logo-maker-workarea text')

      var position = {
        left: 0,
        top: 0
      }
      if (workarea && text) {
        position.left = text.getBoundingClientRect().left - workarea.getBoundingClientRect().left
        position.top = text.getBoundingClientRect().top - workarea.getBoundingClientRect().top
      }

      return position
    },

    iconAlign: debounce(function () {
      // const workarea = this.$el.querySelector('.logo-maker-workarea')
      let textSize = this.getTextSize()
      let textPosition = this.getTextPosition()
      var iconScale = this.iconScale * this.getResize()
      var iconHeight = this.iconSize.height * iconScale
      var iconWidth = this.iconSize.width * iconScale
      var x = 0
      var y = 0

      if (this.hasShape()) {
        iconHeight += 28 * this.iconScale
        iconWidth += 28 * this.iconScale
      }

      if (this.iconPosition === 'left' || this.iconPosition === 'right') {
        let diff = textSize.height - iconHeight
        y = textPosition.top + diff / 2 - 6 * iconScale
      } else if (this.iconPosition === 'top') {
        y = textPosition.top - iconHeight - 2 * iconScale
      } else if (this.iconPosition === 'bottom') {
        y = textPosition.top + textSize.height + 2 * iconScale
      }

      if (this.iconPosition === 'top' || this.iconPosition === 'bottom') {
        x = textPosition.left + textSize.width / 2 - iconWidth + iconWidth / 2
      } else if (this.iconPosition === 'left') {
        x = textPosition.left - iconWidth - 10
      } else if (this.iconPosition === 'right') {
        x = textPosition.left + textSize.width + 10
      }

      this.iconTransform = 'matrix(' + iconScale + ', 0, 0, ' + iconScale + ', ' + x + ', ' + y + ')'

      return true
    }, 100),

    loadIcons (theme) {
      theme = theme || this.theme
      return this.$http.get('static/icons/' + theme + '.json')
        .then((response) => {
          this.icons = response.body
        })
    },

    loadIcon (icon) {
      return this.$http.get(this.getIconUrl(icon))
        .then((response) => response.data)
    },

    getIconUrl (icon) {
      return this.icons[icon]
    },

    prepareIcon (iconHTML) {
      var size

      let iconWrap = document.createElement('div')
      iconWrap.style.visibility = 'hidden'
      iconWrap.style.position = 'absolute'
      iconWrap.style.left = '-9999px'
      iconWrap.innerHTML = iconHTML

      let iconElement = iconWrap.querySelector('svg')
      // var iconElementPath = iconElement.firstElementChild

      iconElement.setAttribute('width', 64)
      iconElement.setAttribute('height', 64)

      // document.body.appendChild(iconWrap)
      size = {
        width: 64, // iconElementPath.getBoundingClientRect().width,
        height: 64 // iconElementPath.getBoundingClientRect().height
      }
      // document.body.removeChild(iconWrap)

      return {
        html: iconWrap.innerHTML,
        size: size
      }
    },

    loadFonts () {
      return this.$http.get('static/fonts.json')
        .then((response) => {
          this.fonts = response.body
        })
    },
    waitFont (font) {
      return new Promise((resolve) => {
        WebFont.load({
          google: {
            families: [font + ':regular,bold,italic,bolditalic']
          },
          active: () => {
            resolve(font)
          }
        })
      })
      .then(() => {
        return font
      })
    },

    changeFont (test) {
      this.waitFont(this.textStyle.fontFamily)
        .then(() => {
          this.textBold = false
          this.textItalic = false
          this.iconAlign()
        })
    },

    addFontStyle (font) {
      const styleText = '@font-face { font-family: ' + font + '; src:url(static/fonts/' + font + '/' + font + '.ttf); font-weight: normal;font-style: normal;}'
      let styleNode = document.createElement('style')
      styleNode.type = 'text/css'
      if (window.attachEvent || window.opera) {
        styleNode.styleSheet.cssText = styleText
      } else {
        let style = document.createTextNode(styleText)
        styleNode.appendChild(style)
      }

      document.head.appendChild(styleNode)

      return font
    },

    changeColorText: debounce(function (val) {
      this.textColor = val.hex
    }, 250),

    changeColorIcon: debounce(function (val) {
      this.iconColor = val.hex
    }, 250),

    listenToolboxClose () {
      var workarea = document.querySelector('.logo-maker-workarea-wrap')

      let listener = (event) => {
        if (this.toolbox) {
          this.toolbox = ''
        }
      }

      workarea.removeEventListener('click', listener)
      setTimeout(() => {
        workarea.addEventListener('click', listener)
        document.addEventListener('keyup', (event) => {
          if (event.keyCode === 27) {
            listener(event)
          }
        })
      }, 100)
    },

    openToolbox (toolbox) {
      this.toolbox = toolbox
    },

    waitIcon (icon) {
      return new Promise((resolve) => {
        if (iconsCache[icon]) {
          this.iconSize = iconsCache[icon]['size']
          this.iconAlign()
          this.iconHTML = iconsCache[icon]['html']
          resolve(icon)
        } else {
          this.loadIcon(icon)
            .then(this.prepareIcon)
            .then((data) => {
              this.iconSize = data.size
              this.iconAlign()
              this.iconHTML = data.html

              iconsCache[icon] = data

              resolve(icon)
            })
        }
      })
    },

    hasShape () {
      return this.shape !== 'none'
    },

    loadShape (shape) {
      return this.$http.get('static/shapes/' + shape + '.svg')
        .then((response) => response.body)
        .then(this.getShapePath)
    },

    getShapePath (shapeSVG) {
      let shapeWrap = document.createElement('div')
      shapeWrap.innerHTML = shapeSVG
      return shapeWrap.querySelector('svg').children[0].outerHTML
    },

    getLogo () {
      var resize = this.getResize()
      var svgInner = this.$el.querySelector('.logo-maker-svg__inner')
      var svgSize = {
        width: svgInner.getBBox().width,
        height: svgInner.getBBox().height
      }
      var textSize = svgInner.querySelector('text').getBBox()

      svgSize.width = svgSize.width / resize
      svgSize.height = svgSize.height / resize

      if (this.iconPosition === 'top' && this.iconPosition && resize !== 1) {
        svgSize.height -= 10 * this.iconScale
      }

      var fontUrl = this.font.Regular

      if (this.textBold && this.textItalic && this.font.BoldItalic) {
        fontUrl = this.font.BoldItalic
      } else if (this.textBold && this.font.Bold) {
        fontUrl = this.font.Bold
      } else if (this.textItalic && this.font.Italic) {
        fontUrl = this.font.Italic
      }
      let params = {
        svgSize: svgSize,
        textSize: textSize,
        text: this.text,
        textColor: this.textColor,
        fontFamily: this.textStyle.fontFamily,
        fontUrl: fontUrl,
        position: this.iconPosition,
        iconSVG: svgInner.querySelector('.icon-wrap'),
        iconScale: parseFloat(this.iconScale)
      }
      var logo = new LogoMaker(params)

      logo.make()
        .then((svg) => {
          var event = {}
          if (window.CustomEvent) {
            event = new CustomEvent('get-logo', {
              detail: {
                svg: svg.outerHTML
              }
            })
          } else {
            event = document.createEvent('CustomEvent')
            event.initCustomEvent('get-logo', true, true, {svg: svg.outerHTML})
          }

          window.document.dispatchEvent(event)
        })
    },

    getResize () {
      return window.innerWidth > 768 ? 1 : 0.7
    }
  },

  watch: {
    icon () {
      if (!this.isReady || this.icon === '') {
        return
      }
      this.waitIcon(this.icon)
    },

    text () {
      this.iconAlign()
    },

    iconScale () {
      this.iconAlign()
    },

    iconPosition () {
      this.iconAlign()
    },

    shape (val) {
      if (this.hasShape()) {
        this.loadShape(val)
        .then((shapePath) => {
          this.shapePath = shapePath
        })
      } else {
        this.shapePath = ''
      }
    },

    shapePath () {
      this.iconAlign()
    },

    theme (theme) {
      this.loadIcons(theme)
    }
  },

  computed: {
    font () {
      if (!this.isReady || this.fonts.length < 1) {
        return {}
      }

      var selectedFont = {}

      this.fonts.forEach((font) => {
        if (font.name === this.textStyle.fontFamily) {
          selectedFont = font
        }
      })

      return selectedFont
    }
  },

  components: {
    'sketch-picker': Sketch
  }
}
</script>

<style lang="scss">

.logo-maker-container {
  width: 100%;
  max-width: 1200px;
  min-height: 700px;
  margin: auto;
  display: flex;
  font-family: 'Roboto', sans-serif;
  position: relative;
}

.logo-maker {
  display: flex;
  flex-flow: wrap nowrap;
  flex: 1;
  overflow: hidden;
}

.logo-maker-menu {
  flex: 1 0 30%;
  max-width: 30%;
  background-color: #F8F8F8;
  border: 1px solid #F8F8F8;
  color: #888888;
  z-index: 2;

  &__item {
    padding: 10px 15px;
    position: relative;
  }

  &__half {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }

  &__half + &__half {
    margin-left: -4px;
  }

  &__label {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 5px 0;
    font-size: 16px;
  }

  &__form-control {
    box-sizing: border-box;
    font-size: 16px;
    padding: 9px 12px;
    width: 100%;
    border: 1px solid #888;
    outline: 0;

    &:active,
    &:focus {
      border-color: #fcca00;
    }
  }

  &__fontstyle {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 15px;
    margin-right: 15px;
  }

  &__fontstyle-label {
    cursor: pointer;
    margin-left: 0;
  }

  &__fontstyle-checkbox {
    position: absolute;
    visibility: hidden;
    left: -9999999px;
    top: -999999px;
  }

  &__fontstyle-icon {
    fill: #888;
    display: inline-flex;
    padding: 2px 5px;
    margin-left: -4px;
  }

  &__fontstyle-checkbox:checked + &__fontstyle-icon {
    fill: #000;
  }

  &__fontstyle-checkbox:disabled + &__fontstyle-icon {
    fill: #ccc;
    cursor: not-allowed;
  }
}

.logo-maker-uicons  {
  display: flex;
  padding-right: 5px;

  &__radio {
    visibility: hidden;
    position: absolute;
    left: -99999px;
  }

  &__label {
    border: 1px solid rgba(0, 0, 0, 0);
    display: block;
    cursor: pointer;
    padding-top: 0px;
    position: relative;
    width: 36px;
    height: 36px;
  }

  &__radio:checked + &__label {
    border-color: #ffd321;
  }

  &__icon {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
  }
}

.logo-maker-icons {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  max-height: 165px;
  overflow-y: auto;
  padding: 5px 7px;
  border: 1px solid #888;
  justify-content: center;

  &__radio {
    visibility: hidden;
    position: absolute;
    left: -9999px;
  }

  &__radio:checked + &__icon {
    border-color: #ccc;
  }

  &__icon {
    padding: 7.2px;
    display: flex;
    cursor: pointer;
    border: 1px solid transparent;
  }

  img {
    width: 32px;
    height: 32px;
  }

  &.logo-maker-icons--shape img {
    width: 42px;
    height: 42px;
  }
}

.logo-maker-workarea-wrap {
  flex: 1 0 50%;
  padding-left: 25px;
  position: relative;
}

.logo-maker-workarea {
  background: url("../static/bg.png");
  height: 620px;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
}

.logo-maker-svg {
  height: 100%;
  width: 100%;
}

.logo-maker-toolbox {
  position: absolute;
  left: 100%;
  top: 0;
  padding: 15px 10px;
  background: #F8F8F8;

  &__close {
    position: absolute;
    right: -30px;
    top: -10px;
    width: 40px;
    height: 40px;
    z-index: 1;
    background: inherit;
    border-radius: 50%;
    cursor: pointer;

    svg {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: 0;
      left: 0;
    }
  }
}

.logo-maker-info {
  margin-top: 25px;
}

.logo-maker-get-logo {
  padding: 10px 0;

  &__btn {
    background: #FFDD54;
    border: 0;
    padding: 13.0px 30px;
    outline: 0;
    cursor: pointer;
  }

  &__btn:active,
  &__btn:hover {
    color: #000;
    background-color: #ffd321;
    border-color: #fcca00;
  }
}



$background: #fff;
$foreground: #fcca00;

.logo-maker-loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
}

.loader {
  font-size:10px;
  margin:50px auto;
  text-indent:-9999em;
  width:11em;
  height:11em;
  border-radius:50%;
  background: $foreground;
  background: linear-gradient(to right,  rgba($foreground,1) 10%,rgba($foreground,0) 42%);
  position: relative;
  animation:load3 1.4s infinite linear;
  transform: translateZ(0);

  &:before {
    width:50%;
    height:50%;
    background: $foreground;
    border-radius: 100% 0 0 0;
    position:absolute;
    top:0;
    left:0;
    content:'';
  }

  &:after {
    background:$background;
    width:75%;
    height:75%;
    border-radius:50%;
    content:'';
    margin:auto;
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
  }

}

@media (max-width: 760px) {
  .logo-maker-container {
    min-height: 0;
  }
  .logo-maker-workarea-wrap {
    width: 100%;
    padding: 0 15px;
  }
  .logo-maker-workarea {
    height: 320px;
    overflow: hidden;
  }
  .logo-maker {
    flex-wrap: wrap;
  }
  .logo-maker-menu {
    min-width: 100%;
    // display: none;
  }
}


@mixin load3-frames() {

  0% {
  	-webkit-transform:rotate(0deg);
  	transform:rotate(0deg);
  }

  100% {
  	-webkit-transform:rotate(360deg);
  	transform:rotate(360deg);
  }

}

@-webkit-keyframes load3 {@include load3-frames;}
@keyframes load3 {@include load3-frames;}

</style>



// WEBPACK FOOTER //
// App.vue?92f7408e